/**
 * Enumération du type de barème
 */
export enum TypeBareme {
    SANS = 0,
    BAREME_FISCAL = 1,
    BAREME_SNCF = 2
}